var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6839 7.78582C26.8007 4.78934 22.117 4.78934 19.2215 7.78582L18.0003 9.05744L16.779 7.78582C13.8959 4.78934 9.2121 4.78934 6.31668 7.78582C3.4335 10.7823 3.4335 15.6294 6.31668 18.6262L17.9753 30.7256L18.0005 30.7005L18.0256 30.7256L29.6842 18.6262C32.5674 15.6297 32.5674 10.7826 29.6842 7.78582H29.6839Z",
    fill: "url(#paint0_linear_2023_20469)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7356 9.71896C25.333 7.22189 21.4298 7.22189 19.017 9.71896L17.9993 10.7786L16.9815 9.71896C14.5789 7.22189 10.6758 7.22189 8.26292 9.71896C5.86028 12.216 5.86028 16.2553 8.26292 18.7526L17.9784 28.8355L17.9994 28.8145L18.0204 28.8355L27.7359 18.7526C30.1385 16.2555 30.1385 12.2163 27.7359 9.71896H27.7356Z",
    fill: "url(#paint1_linear_2023_20469)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7912 11.6521C23.8691 9.65442 20.7466 9.65442 18.8163 11.6521L18.0021 12.4998L17.188 11.6521C15.2659 9.65442 12.1434 9.65442 10.2131 11.6521C8.29096 13.6497 8.29096 16.8811 10.2131 18.879L17.9855 26.9453L18.0023 26.9285L18.019 26.9453L25.7914 18.879C27.7136 16.8814 27.7136 13.65 25.7914 11.6521H25.7912Z",
    fill: "#E1DEF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8429 13.5852C22.4013 12.087 20.0595 12.087 18.6117 13.5852L18.0011 14.221L17.3905 13.5852C15.9489 12.087 13.607 12.087 12.1593 13.5852C10.7177 15.0835 10.7177 17.507 12.1593 19.0054L17.9886 25.0551L18.0012 25.0425L18.0138 25.0551L23.8431 19.0054C25.2847 17.5072 25.2845 15.0836 23.8429 13.5852Z",
    fill: "url(#paint2_linear_2023_20469)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0787 15.2188C21.0578 14.1578 19.3993 14.1578 18.3741 15.2188L17.9417 15.6691L17.5093 15.2188C16.4884 14.1578 14.8299 14.1578 13.8047 15.2188C12.7838 16.2798 12.7838 17.9961 13.8047 19.0572L17.9328 23.3414L17.9418 23.3325L17.9507 23.3414L22.0788 19.0572C23.0997 17.9962 23.0995 16.28 22.0787 15.2188Z",
    fill: "url(#paint3_linear_2023_20469)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7135 16.572C20.029 15.8606 18.917 15.8606 18.2296 16.572L17.9396 16.8739L17.6497 16.572C16.9652 15.8606 15.8532 15.8606 15.1657 16.572C14.4812 17.2834 14.4812 18.4342 15.1657 19.1457L17.9337 22.0183L17.9397 22.0123L17.9456 22.0183L20.7136 19.1457C21.3981 18.4343 21.398 17.2835 20.7135 16.572Z",
    fill: "url(#paint4_linear_2023_20469)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3522 17.9252C19.0041 17.5634 18.4385 17.5634 18.0889 17.9252L17.9414 18.0788L17.794 17.9252C17.4458 17.5634 16.8803 17.5634 16.5306 17.9252C16.1825 18.287 16.1825 18.8723 16.5306 19.2342L17.9384 20.6952L17.9415 20.6922L17.9445 20.6952L19.3523 19.2342C19.7004 18.8724 19.7004 18.2871 19.3522 17.9252Z",
    fill: "url(#paint5_linear_2023_20469)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2023_20469",
    x1: 2.3543,
    y1: 38.2818,
    x2: 39.8692,
    y2: 23.9358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2023_20469",
    x1: 4.96094,
    y1: 35.1323,
    x2: 36.2234,
    y2: 23.1773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2023_20469",
    x1: 10.1781,
    y1: 28.8332,
    x2: 28.9356,
    y2: 21.6602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2023_20469",
    x1: 12.4017,
    y1: 26.017,
    x2: 25.6851,
    y2: 20.9373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2023_20469",
    x1: 14.225,
    y1: 23.8123,
    x2: 23.1317,
    y2: 20.4063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2023_20469",
    x1: 16.0522,
    y1: 21.6076,
    x2: 20.5821,
    y2: 19.8753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.4eb998099331e065f82fc13d5ade904b.svg";
export { ForwardRef as ReactComponent };